import AppService from 'common/app-service';
import api from 'config/axios';

export default class TransactionsService extends AppService {
  constructor() {
    super('banking/transactions', api);
  }

  async getAll(params?: {
    accountType?: string | undefined;
    tipo?: string | undefined;
    dateMin?: string | undefined;
    dateMax?: string | undefined;
    payDueDateStart?: string | undefined;
    payDueDateEnd?: string | undefined;
    page?: number | undefined;
    limit?: number | undefined;
  }): Promise<{ items: any[]; limit: number; page: number; total: number }> {
    const queryParams = {
      account_type: params?.accountType,
      type: params?.tipo,
      date_min: params?.dateMin,
      date_max: params?.dateMax,
      pay_due_date_start: params?.payDueDateStart,
      pay_due_date_end: params?.payDueDateEnd,
      page: params?.page,
      limit: params?.limit,
    };

    return this.api.get(this.root(), { params: queryParams }).then((response) => response.data);
  }

  async createMultipleBankSlips(file: File): Promise<{ message: string; processingId: string }> {
    const formData = new FormData();
    formData.append('file', file);
    return this.api.post(this.root('bank-slip/multiple'), formData).then((response) => response.data);
  }

  async getProcessingStatus(id: string): Promise<any> {
    return this.api.get(this.root(`processings/${id}`)).then((response) => response.data);
  }
}
